<template>
  <div>
    <el-dialog :visible.sync="visible" :append-to-body="true" >
      <div class="box-print" v-loading="loading">
        
        <div style="width: 100%; text-align: center"  id="print" >
          <div style="text-align: center;font-size:30px;font-weight:bold;">客服呼叫中心工作单</div>
          <!-- <h1 style="text-align: center">客服呼叫中心工作单</h1> -->
          <div class="table-header" >
            <div>打印时间: {{ data.printTime }}</div>
            <div>打印人: {{ nick_name }}</div>
            <div>工单编号: {{ data.wordId }}</div>
          </div>
          <table border="1" width="100%" >
            <tr class="tr1">
              <td style="width: 80px; font-weight: bold">反映人</td>
              <td>{{ data.repairEmp }}</td>
              <td style="font-weight: bold">联系电话</td>
              <td>{{ data.repairPhone }}</td>
              <td style="font-weight: bold">反映时间</td>
              <td colspan="2">
                {{ data.createTime && dayjs(data.createTime).format('YYYY-MM-DD HH:mm') }}
              </td>
            </tr>
            <tr>
              <td style="font-weight: bold">反映形式</td>
              <td>{{ data.form }}</td>
              <td style="font-weight: bold">反映来源</td>
              <td>{{ data.source }}</td>
              <td style="font-weight: bold">反映类型</td>
              <td colspan="2">{{ data.repairTypeId }}</td>
            </tr>
            <tr>
              <td style="font-weight: bold">紧急程度</td>
              <td>{{ data.isExigency }}</td>
              <td colspan="5"></td>
            </tr>
            <tr>
              <td style="height: 80px; font-weight: bold">反映内容</td>
              <td style="height: 80px; text-align: left; padding: 10px 10px" colspan="6">
                <span>{{ data.repairDesc }}</span>
              </td>
            </tr>
            <tr>
              <td style="font-weight: bold">受理单位</td>
              <td>{{ data.manageDeptName }}</td>
              <td style="font-weight: bold">受理人</td>
              <td>{{ data.manageUserName }}</td>
              <td style="font-weight: bold">受理时间</td>
              <td colspan="2">
                {{ data.manageTime && dayjs(data.manageTime).format('YYYY-MM-DD HH:mm') }}
              </td>
            </tr>
            <tr>
              <td style="height: 80px; font-weight: bold">受理备注</td>
              <td colspan="6" style="height: 80px; text-align: left; padding: 10px 10px">
                <span>{{ data.remark1 }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="7" style="font-weight: bold">受理材料</td>
            </tr>
            <tr style="font-weight: bold">
              <td>编号</td>
              <td>物料名称</td>
              <td style="max-width: 150px">规格型号</td>
              <td>材质</td>
              <td style="width: 80px">数量</td>
              <td>单价</td>
              <td style="min-width: 55px">总金额</td>
            </tr>
            <tr v-for="(item, index) in data.materials" :key="item">
              <td>{{ index + 1 }}</td>
              <td>{{ item.costName }}</td>
              <td>{{ item.materialType }}</td>
              <td>{{ item.materials }}</td>
              <td>{{ item.num }}</td>
              <td>{{ item.price + '元/' + changeData(item.unit, 6) }}</td>
              <td>{{ item.totalAmount + '元' }}</td>
            </tr>
            <tr v-for="item in trNum" :key="item">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td style="font-weight: bold">处理部门</td>
              <td>{{ data.processDeptId }}</td>
              <td style="font-weight: bold">处理人</td>
              <td>{{ data.processMaintainPeople }}</td>
              <td style="font-weight: bold">处理时间</td>
              <td colspan="2">
                {{
                  data.processFinishTime && dayjs(data.processFinishTime).format('YYYY-MM-DD HH:mm')
                }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" >
        <el-button @click="visible = false" v-loading="loading2">取 消</el-button>
        <el-button type="primary" @click="print" v-loading="loading2">打 印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPrint, source, manageType, selectDept } from '@/api/v4ward/repair/repairinfo';
import { getDictionary } from '@/api/common';

export default {
  props: ['allComplainTypeList', 'allExigencyList'],
  //           反映类型              紧急程度
  name: 'InspirationView',
  data() {
    return {
      data: {
        printTime: '',
      },
      visible: 0,
      loading2:false,
      loading: true,
      loadingNum:0,
      sourceList: [], //反映来源
      manageTypeList: [], //反映形式
      selectDeptList: [], //处理部门
      unitList: [], //单价单位
      trNum: 10,
      nick_name: JSON.parse(localStorage.getItem('saber-userInfo')).content.nick_name,
    };
  },
  created() {
    this.aweitData();
  },
  methods: {
    showPrint(falg, id) {
      this.loading = true;
      this.trNum = 10;
      this.visible = falg;
      getPrint({
        id: id,
      }).then((res) => {
        this.data = res.data;
        this.data.printTime = this.dayjs().format('YYYY-MM-DD HH:mm:ss');

        if (res.data.materials.length) {
          this.trNum = this.trNum - res.data.materials.length;
        }
        if ((this.data.form != '' || this.data.form == 0) && this.data.form != null) {
          this.data.form = this.changeData(this.data.form, 1);
        }
        if ((this.data.source != '' || this.data.source == 0) && this.data.source != null) {
          this.data.source = this.changeData(this.data.source, 2);
        }
        if (
          (this.data.repairTypeId != '' || this.data.repairTypeId == 0) &&
          this.data.repairTypeId != null
        ) {
          this.data.repairTypeId = this.changeData(this.data.repairTypeId, 3);
        }
        if (
          (this.data.isExigency != '' || this.data.isExigency == 0) &&
          this.data.isExigency != null
        ) {
          this.data.isExigency = this.changeData(this.data.isExigency, 4);
        }
        if (
          (this.data.processDeptId != '' || this.data.processDeptId == 0) &&
          this.data.processDeptId != null
        ) {
          this.data.processDeptId = this.changeData(this.data.processDeptId, 5);
        }

        this.loadShow(50);
         
      });
    },
    print() {
      this.$confirm('确认打印吗？')
        .then((_) => {
          this.loading2 = true;
          let dom = document.getElementById('print').innerHTML
          setTimeout(() => {
            this.$Print({
              // id: 'test',
              html: dom,
            });
            this.loading2 = false;
          }, 100);
        })
        .catch((_) => {});
    },
    changeData(val, type) {
      if (type == 1) {
        var obj = this._.find(this.manageTypeList, function (o) {
          return o.dictKey == val;
        });
        return obj.dictValue;
      } else if (type == 2) {
        var obj = this._.find(this.sourceList, function (o) {
          return o.dictKey == val;
        });
        return obj.dictValue;
      } else if (type == 3) {
        var obj = this._.find(this.allComplainTypeList, function (o) {
          return o.id == val;
        });

        return obj.typeName;
      } else if (type == 4) {
        var obj = this._.find(this.allExigencyList, function (o) {
          return o.dictKey == val;
        });

        return obj.dictValue;
      } else if (type == 5) {
        var obj = this._.find(this.selectDeptList, function (o) {
          return o.key == val;
        });
        return obj.title;
      } else if (type == 6) {
        var obj = this._.find(this.unitList, function (o) {
          return o.dictKey == val;
        });

        return obj.dictValue;
      }
      this.loadShow(40);
    },
    loadShow(num) {
      console.log(this.loadingNum)
      this.loadingNum += num;
      
      if( this.loadingNum >= 100){
        this.loading = false;
      }
    },
    aweitData() {
      source().then((res) => {
        this.loadShow(20);
        this.sourceList = res.data;
      });
      manageType().then((res) => {
        this.loadShow(20);
        this.manageTypeList = res.data;
      });
      selectDept().then((res) => {
        this.loadShow(20);
        this.selectDeptList = res.data;
      });
      getDictionary('unit').then((res) => {
        this.unitList = res.data;
      });
    },
  },
  mounted() {
    // this.$nextTick(()=>{
    //     this.visible = true;
    // });
  },
};
</script>
<style scoped>

.box-print {
  margin: 0 auto;
  padding: 20px;
  padding-top: 0px;
  /* width: 700px; */
  /* height: 600px; */
  /* background: #fff; */
  text-align: center;
}
td {
  text-align: center;
}
.table-header {
  display: flex;
  margin-top: 30px;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
}
td {
  height: 40px;
  line-height: 40px;
  text-align: center;
}
</style>
